import { render } from "./OptionIcon12.vue.js?vue&type=template&id=5a66f739!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./OptionIcon12.vue?vue&type=template&id=5a66f739"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__